import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getProductPackageApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const getProductPackageListApi = createAsyncThunk('getProductPackageList', async (payload) => {
  // console.log('payload', payload);
  return await getProductPackageApi(payload);
});

const getProductPackageListSlice = createSlice({
  name: 'getProductPackageList', // Unique Name
  initialState,
  reducers: {
    getProductPackageListReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getProductPackageListApi.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(getProductPackageListApi.fulfilled, (state, action) => {
        const { message = '', data = [], payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(getProductPackageListApi.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { getProductPackageListReset } = getProductPackageListSlice.actions;

export default getProductPackageListSlice.reducer;
